import {
  AcceptResultSchema,
  BFF_ROUTES,
  SignContextResponseSchema,
  type AcceptResult,
  type SignatureEvent,
  type SignContextResponse,
} from '@rheora/enrollment-contract';

import { bffGet, bffPost } from './bff-client';

/**
 * Typed fetchers for the E-SF06 sign step. Thin: request + validate against the
 * shared contract schema. Pages call the `sign.queries` hooks, never these.
 *
 * ── THE BFF ROUTES ARE NOT WIRED YET ───────────────────────────────────────
 * The at-accept saga owns `/bff/sign/*` and is built separately. Until it lands,
 * `getSignContext`/`postSignAccept` fail loud (a 404/501 becomes a `BffError`);
 * the sign page renders a pending state and NEVER fakes a signed success (US
 * fail-loud posture; ADR-0009). No card data and no SSN cross this seam — the
 * click IS the signature and identity was captured server-side at E-SF05.
 */

/** Read the sign context (start-date constraints, domestic disclosures, deposit gate). */
export async function getSignContext(candidateId: string): Promise<SignContextResponse> {
  const path = `${BFF_ROUTES.signContext}?candidate=${encodeURIComponent(candidateId)}`;
  return bffGet(path, SignContextResponseSchema);
}

/**
 * Submit the click-wrap SignatureEvent + accept the self-serve quote.
 *
 * ⚠️ THE KEY IS REQUIRED, NOT OPTIONAL. Accept is the one POST in the funnel a
 * customer can fire twice with a double-click, and it creates a contract. Making
 * the caller supply an OPERATION-scoped key (rather than letting `bffPost` mint a
 * per-request one) is what puts the BFF's idempotency layer back in the path — see
 * `sign-operation.service.ts` for the QA finding and the reasoning.
 */
export async function postSignAccept(
  event: SignatureEvent,
  idempotencyKey: string,
): Promise<AcceptResult> {
  return bffPost(BFF_ROUTES.signAccept, event, AcceptResultSchema, { idempotencyKey });
}
